import { LAYERS } from 'shared';
import TileLayer from 'ol/layer/Tile';
import BingMaps from 'ol/source/BingMaps.js';
import XYZ from "ol/source/XYZ";
export default class BaseLayer {
    map = null;
    layer = null;

    constructor(map) {
        this.map = map;
        this.init();
    }

    init() {
        this.layer = new TileLayer({
            title: 'Alaptérkép',
            type: LAYERS.TYPES.BASE,
            visible: true,
            source: new XYZ({
                url: 'https://mt0.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
                maxZoom: 22,
                crossOrigin: 'anonymous',
            }),
        });
    }

    getLayer() {
        return this.layer;
    }

    update(layer) {
        this.layer.setVisible(layer.visible);
    }
}
